
    import { defineComponent } from 'vue'

    import { footer } from '@/common/json-ld/page-elements'

    import FooterContact from '@/common/components/footer/FooterContact.vue'
    import FooterCopyright from '@/common/components/footer/FooterCopyright.vue'
    import FooterMediaCenter from '@/common/components/footer/FooterMediaCenter.vue'
    import FooterSocial from '@/common/components/footer/FooterSocial.vue'

    export default defineComponent({
        components: {
            FooterContact,
            FooterCopyright,
            FooterMediaCenter,
            FooterSocial
        },
        props: {
            privacyPolicy: {
                type: Boolean,
                default: false
            }
        },
        setup () {
            return {
                jsonLd: footer()
            }
        }
    })
